import { render, staticRenderFns } from "./DeleteProfile.vue?vue&type=template&id=580c8d3a&scoped=true"
import script from "./DeleteProfile.vue?vue&type=script&lang=js"
export * from "./DeleteProfile.vue?vue&type=script&lang=js"
import style0 from "./DeleteProfile.vue?vue&type=style&index=0&id=580c8d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580c8d3a",
  null
  
)

export default component.exports